import { toggleScrollLock } from 'common/utils';
import MobileMenu from 'apps/application/mobile-menu';
import MobileNavigation from 'apps/application/aveeno/mobile-navigation';
import DesktopKeyboardNavigation from 'apps/application/aveeno/desktop-keyboard-navigation';

const SIDE_NAV_CLASS = 'header__sidenav';
const SIDE_NAV_CONTENT_CLASS = 'header__sidenav-alt';
const SIDE_NAV_OVERLAY_CLASS = 'header__sidenav-overlay';
export const HEADER_OVERLAY_CLASS = 'header__overlay';
export const HEADER_OVERLAY_VISIBLE_CLASS = 'header__overlay--visible';
export const HEADER_OVERLAY_FULL_HEIGHT_CLASS = 'header__overlay--full-height';
export const HEADER_SIDENAV_VISIBLE_CLASS = 'header__sidenav--visible';
export const HEADER_SHOP_CONTAINER = 'header__shop-link-hover-container';
export const HEADER_SHOP_CONTAINER_VISIBLE_CLASS =
  'header__shop-link-hover-container--visible';
const ABOUT_US_SHOP_CONTAINER = 'header__about-us-link-hover-container';
const ABOUT_US_SHOP_CONTAINER_VISIBLE_CLASS =
  'header__about-us-link-hover-container--visible';
const HIDE_HEADER_DELAY = 200;
const OVERLAY_SHOP = 'overlay__shop';
const OVERLAY_ABOUT_US = 'overlay__about-us';

let hamburgerMenu;
let hamburgerMenuAlt;
let headerOverlay;
let headerSideNav;
let headerSideNavOverlay;
let isOpen;
let shopContainer;
let aboutUsContainer;
let shopLink;
let aboutUsLink;
let timer;
let aboutTimer;
let activeOverlay = null;

export const getState = function() {
  return isOpen;
};

export const toggleButtonVisibility = function(el = hamburgerMenu) {
  el && el.classList.toggle('header__hamburger-menu--hidden');
};

export const showShopContainer = function(el = shopContainer) {
  el && el.classList.add(HEADER_SHOP_CONTAINER_VISIBLE_CLASS);
};

export const hideShopContainer = function(el = shopContainer) {
  el && el.classList.remove(HEADER_SHOP_CONTAINER_VISIBLE_CLASS);
};

export const showAboutUsContainer = function(el = aboutUsContainer) {
  el && el.classList.add(ABOUT_US_SHOP_CONTAINER_VISIBLE_CLASS);
};

export const hideAboutUsContainer = function(el = aboutUsContainer) {
  el && el.classList.remove(ABOUT_US_SHOP_CONTAINER_VISIBLE_CLASS);
};

export const showHeaderOverlay = function({ isFullHeight } = {}) {
  const classes = [HEADER_OVERLAY_VISIBLE_CLASS];
  if (isFullHeight) {
    classes.push(HEADER_OVERLAY_FULL_HEIGHT_CLASS);
  }
  headerOverlay && headerOverlay.classList.add(...classes);
};

export const hideHeaderOverlay = function() {
  headerOverlay &&
    headerOverlay.classList.remove(
      HEADER_OVERLAY_VISIBLE_CLASS,
      HEADER_OVERLAY_FULL_HEIGHT_CLASS
    );
};

export const showHeaderSidenav = function() {
  headerSideNav && headerSideNav.classList.add(HEADER_SIDENAV_VISIBLE_CLASS);
};

export const hideHeaderSidenav = function() {
  headerSideNav && headerSideNav.classList.remove(HEADER_SIDENAV_VISIBLE_CLASS);
};

export const toggleVisibility = function() {
  isOpen = !isOpen;

  toggleScrollLock(`.${SIDE_NAV_CONTENT_CLASS}`, isOpen);

  if (isOpen) {
    showHeaderSidenav();
  } else {
    hideHeaderSidenav();
  }
};

export const attachListeners = ({
  hamburgerMenu,
  headerSideNavOverlay,
  hideHeaderOverlay,
  hideShopContainer,
  hideAboutUsContainer,
  setTimeout,
  shopLink,
  aboutUsLink,
  showHeaderOverlay,
  showShopContainer,
  showAboutUsContainer,
  toggleVisibility,
}) => {
  hamburgerMenu &&
    hamburgerMenu.addEventListener('click', () => {
      toggleVisibility();
    });

  headerSideNavOverlay &&
    headerSideNavOverlay.addEventListener('click', () => {
      toggleVisibility();
    });

  const handleMouseEnterEvent = function(link, callbackFn) {
    if (link) {
      link.addEventListener('mouseenter', callbackFn);
    }
  };

  const handleMouseLeaveEvent = function(link, callbackFn) {
    if (link) {
      link.addEventListener('mouseleave', callbackFn);
    }
  };

  const handleClickEvent = function(link, callbackFn) {
    if (link) {
      link.addEventListener('click', callbackFn);
    }
  };

  handleClickEvent(shopLink, () => {
    activeOverlay = OVERLAY_SHOP;
    clearTimeout(timer);
    showHeaderOverlay();
    showShopContainer();
  });

  handleClickEvent(aboutUsLink, () => {
    activeOverlay = OVERLAY_ABOUT_US;
    clearTimeout(aboutTimer);
    showHeaderOverlay();
    showAboutUsContainer();
  });

  handleMouseEnterEvent(shopLink, () => {
    activeOverlay = OVERLAY_SHOP;
    clearTimeout(timer);
    showHeaderOverlay();
    showShopContainer();
  });

  handleMouseEnterEvent(aboutUsLink, () => {
    activeOverlay = OVERLAY_ABOUT_US;
    clearTimeout(aboutTimer);
    showHeaderOverlay();
    showAboutUsContainer();
  });

  handleMouseLeaveEvent(shopLink, () => {
    timer = setTimeout(() => {
      if (activeOverlay === OVERLAY_SHOP) {
        hideHeaderOverlay();
      }
      hideShopContainer();
    }, HIDE_HEADER_DELAY);
  });

  handleMouseLeaveEvent(aboutUsLink, () => {
    aboutTimer = setTimeout(() => {
      if (activeOverlay === OVERLAY_ABOUT_US) {
        hideHeaderOverlay();
      }
      hideAboutUsContainer();
    }, HIDE_HEADER_DELAY);
  });

  new MobileNavigation(document.querySelector('[data-js="mobile-navigation"]'));

  hamburgerMenuAlt = new MobileMenu('.header__sidenav-alt', {
    textLinkClasses: 'header__sidenav-text-link',
    toggleSidebar: toggleVisibility,
  });

  new DesktopKeyboardNavigation(
    document.querySelector('[data-js="desktop-navigation"]')
  );
};

if (!global.__isHeaderInitialized) {
  global.__isHeaderInitialized = true;

  hamburgerMenu = document.getElementsByClassName('header__hamburger-menu')[0];
  headerOverlay = document.getElementsByClassName(HEADER_OVERLAY_CLASS)[0];
  headerSideNav = document.getElementsByClassName(SIDE_NAV_CLASS)[0];
  headerSideNavOverlay = document.getElementsByClassName(
    SIDE_NAV_OVERLAY_CLASS
  )[0];
  isOpen = false;
  shopContainer = document.getElementsByClassName(HEADER_SHOP_CONTAINER)[0];
  aboutUsContainer = document.getElementsByClassName(
    ABOUT_US_SHOP_CONTAINER
  )[0];
  shopLink = document.getElementsByClassName(
    'header__shop header__navbar-item'
  )[0];
  aboutUsLink = document.getElementsByClassName(
    'header__about-us header__navbar-item'
  )[0];

  const listenerParams = {
    hamburgerMenu,
    hamburgerMenuAlt,
    headerOverlay,
    headerSideNavOverlay,
    hideHeaderOverlay,
    hideShopContainer,
    hideAboutUsContainer,
    setTimeout,
    shopLink,
    aboutUsLink,
    showHeaderOverlay,
    showShopContainer,
    showAboutUsContainer,
    toggleVisibility,
  };

  attachListeners(listenerParams);
}
